import React from 'react'
import Aux from '../ReactAux/ReactAux'
import ModalError from 'components/UI/Modal/ModalError'

const withErrorHandling = WrappedComponent => ({ children, handlingError, closedErrorModal }) => {
  return (
    <Aux>
      {handlingError.showError && <ModalError
        showModal={handlingError.showError}
        closeModal={closedErrorModal}
        errorMessage={handlingError.errorMessage} />}
      {children}
    </Aux>

  );
};

const ErrorHandling = withErrorHandling(({ children }) => <div>{children}</div>)


export default ErrorHandling;



// WEBPACK FOOTER //
// ./src/hoc/ErroHandling/index.js